<template>
    <el-card>
        <div slot="header">
            <span v-if="vehicleData.licensePlate">{{`Vehicle #${vehicleData.licensePlate}, `}}</span>
            <span>{{` ${vehicleData.make} `}}</span>
            <span>{{` ${vehicleData.model} `}}</span>
            <span v-if="vehicleData.vin">{{` , VIN: ${vehicleData.vin} `}}</span>
        </div>
        <div class="card-body">
        <div>
            <h4>Name:</h4>
            <div class="graybar">
            <span>{{ guestData.firstName }}</span>&nbsp;<span v-if="guestData.lastName">{{ guestData.lastName }}</span>
            </div>
        </div>
        <div v-if="guestData.phone">
            <h4>Phone number:</h4>
            <div class="graybar">
            {{ guestData.phoneCode + ' ' + guestData.phone }}
            </div>
        </div>
        <div>
            <h4>Date:</h4>
            <div class="graybar">
            {{ guestData.time }}
            </div>
        </div>
        </div>
    </el-card>
</template>

<script>
import ComputedStorage from '../mixins/computed-storage'

export default {
    mixins: [ComputedStorage]
}
</script>

<style lang="scss" scoped>
.el-card {
  margin-bottom: 24px;
}
.graybar {
  border-radius: 4px;
  background-color: #e9e9e9;
  padding: 10px;
}
</style>